import {
  Modal,
  ModalBody,
  ModalTitle,
  ModalFooter,
  ModalFooterAlignment,
  MODAL_INNER_GAP,
} from 'design-system/src/components/Modal';
import { Typography } from 'design-system/src/components/Typography/Typography';
import Button from 'design-system/src/components/Button/Button';
import { Drug, Patient } from '../../../api';
import { ExtraInfoTable } from '../../ExtraInfoTable/ExtraInfoTable';
import Hairline from 'design-system/src/components/Hairline/Hairline';

export type AdditionalInput = {
  needs_draft_review?: boolean;
};

type LmnRespondedModalProps = {
  closeModal: () => void;
  patient: Patient;
  drug: Drug;
  variant: 'approve' | 'decline';
};

const LmnRespondedModal = ({ closeModal, patient, drug, variant }: LmnRespondedModalProps) => {
  const extraInfoData = [
    { label: 'Patient', value: `${patient?.first_name} ${patient?.last_name}` },
    { label: 'Drug', value: drug?.name },
  ];

  const modalTitle = `Letter of Medical Necessity ${variant === 'approve' ? 'approved' : 'declined'}`;
  const modalCopy =
    variant === 'approve'
      ? 'Tandem will include the Letter of Medical Necessity with the PA request.'
      : 'Tandem will not include the Letter of Medical Necessity with the PA request.';

  return (
    <Modal onClose={closeModal}>
      <ModalTitle>{modalTitle}</ModalTitle>

      <ModalBody>
        <ExtraInfoTable
          data={extraInfoData}
          minFieldLabelWidth="80px"
          marginTop="0"
          tableMarginBottom={MODAL_INNER_GAP}
          hairlineComponent={<Hairline $marginTop="0" $marginBottom="0" />}
        />

        <Typography>{modalCopy}</Typography>
      </ModalBody>

      <ModalFooter align={ModalFooterAlignment.Right}>
        <Button to="/tasks">Return to Tasks</Button>
      </ModalFooter>
    </Modal>
  );
};

export default LmnRespondedModal;
